import React from 'react';
import {
  Box,
  Grid,
  Paper,
  Typography,
  TextField,
} from '@mui/material';



const Step5Gaji = ({ form, setForm }) => {
  const formatNumberID = (v) => {
    if (v === null || v === undefined) return '';
    const digits = String(v).replace(/[^\d]/g, '');
    return digits.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    // Auto format thousand separators for salary field
    if (name === 'expectedSalary') {
      const formatted = formatNumberID(value);
      setForm(prev => ({ ...prev, [name]: formatted }));
      return;
    }
    setForm(prev => ({ ...prev, [name]: value }));
  };

  return (
    <Box sx={{ maxWidth: 1100, mx: 'auto', my: 4, p: 2 }}>
      <Paper 
        elevation={3} 
        sx={{ 
          p: 4, 
          backgroundColor: '#ffffff', 
          mb: 3,
          border: '2px solid #1976d2',
          borderRadius: 2,
          boxShadow: '0 4px 20px rgba(25, 118, 210, 0.15)'
        }}
      >
        <Grid container spacing={3}>
          {/* Header Section */}
          <Grid item xs={12}>
            <Box 
              sx={{ 
                display: 'flex', 
                alignItems: 'center', 
                mb: 3,
                pb: 2,
                borderBottom: '2px solid #e3f2fd'
              }}
            >
              <Typography 
                variant="h5" 
                sx={{ 
                  fontWeight: 'bold', 
                  color: '#1976d2',
                  fontSize: '1.5rem',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1
                }}
              >
                <span>💰</span>
                Data Gaji & Tunjangan
              </Typography>
            </Box>
            <Typography 
              variant="body1" 
              sx={{ 
                color: '#666', 
                mb: 3,
                fontStyle: 'italic',
                fontSize: '0.95rem'
              }}
            >
              Silakan isi informasi gaji dan tunjangan yang Anda harapkan. Data ini akan digunakan sebagai pertimbangan dalam proses rekrutmen.
            </Typography>
          </Grid>

          {/* Salary Expectations */}
          <Grid item xs={12}>
            <Paper elevation={1} sx={{ p: 3, backgroundColor: '#f8f9fa' }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 2, color: '#495057' }}>
                Informasi Gaji dan Tunjangan
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField 
                    label="Berapa besar gaji yang anda harapkan dari Perusahaan?"
                    name="expectedSalary"
                    value={form.expectedSalary || ''}
                    onChange={handleChange}
                    fullWidth
                    size="medium"
                    placeholder="Contoh: 10.000.000"
                    helperText="(How much salary do you expect from the company?)"
                    variant="outlined"
                    required
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 2,
                        '&:hover fieldset': {
                          borderColor: '#1976d2',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: '#1976d2',
                        },
                      },
                      '& .MuiInputLabel-root': {
                        fontWeight: 500,
                        color: '#555',
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField 
                    label="Selain gaji, kondisi kerja / tunjangan dan fasilitas apa yang saudara inginkan?"
                    name="benefitsWanted"
                    value={form.benefitsWanted || ''}
                    onChange={handleChange}
                    fullWidth
                    size="medium"
                    placeholder="Contoh: BPJS Kesehatan, Tunjangan transport, Meal allowance, dll"
                    helperText="(Please mention other fringe benefits / facilities you wish to have excluded salary?)"
                    multiline
                    rows={3}
                    variant="outlined"
                    required
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 2,
                        '&:hover fieldset': {
                          borderColor: '#1976d2',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: '#1976d2',
                        },
                      },
                      '& .MuiInputLabel-root': {
                        fontWeight: 500,
                        color: '#555',
                      },
                    }}
                  />
                </Grid>
              </Grid>
            </Paper>
          </Grid>

        </Grid>
      </Paper>
    </Box>
  );
};

export default Step5Gaji;
